import { useCompanyId } from './useCompanyId';
import { useDemoCompanyId } from './useDemoCompanyId';

// 🎯 Demo 조건에 따라 적절한 companyId를 반환하는 Hook
export const useDemoAwareCompanyId = (): { companyId: string } => {
  const { companyId } = useCompanyId();
  const demoCompanyId = useDemoCompanyId();

  // Demo companyId가 유효하면 사용, 아니면 원본 사용
  return { companyId: demoCompanyId || companyId };
};
